import { render, staticRenderFns } from "./manualCard.vue?vue&type=template&id=5f8fb58b&scoped=true&"
import script from "./manualCard.vue?vue&type=script&lang=tsx&"
export * from "./manualCard.vue?vue&type=script&lang=tsx&"
import style0 from "./manualCard.vue?vue&type=style&index=0&id=5f8fb58b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8fb58b",
  null
  
)

export default component.exports